/* Target Group Section – Sacred Modern Design
 * Light section showing who AYU is for
 * Three audience cards
 */
import { TARGET_GROUPS } from "@/lib/constants";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { Heart, Briefcase, Rocket } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";

const groupIcons = { heart: Heart, briefcase: Briefcase, rocket: Rocket };

export default function TargetGroupSection() {
  const { t } = useI18n();
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="section-ivory py-24 lg:py-32 relative" ref={ref}>
      <div className="gold-line w-full absolute top-0" />

      <div className="container">
        <div
          className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span className="text-sm font-semibold tracking-[0.2em] uppercase text-[oklch(0.52_0.09_128)]" style={{ fontFamily: "var(--font-body)" }}>
            {t("landing.targetGroup.badge")}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[oklch(0.25_0.04_50)] mt-4 mb-6">
            {t("landing.targetGroup.heading1")} <span className="text-[oklch(0.52_0.09_128)]">{t("landing.targetGroup.heading2")}</span>
          </h2>
          <p className="text-lg text-[oklch(0.45_0.04_50)]" style={{ fontFamily: "var(--font-body)" }}>
            {t("landing.targetGroup.description")}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {TARGET_GROUPS.map((group, i) => {
            const Icon = groupIcons[group.icon as keyof typeof groupIcons];
            return (
              <div
                key={i}
                className={`bg-white rounded-2xl p-8 text-center shadow-sm border border-[oklch(0.88_0.02_80)] hover:shadow-lg hover:border-[oklch(0.52_0.09_128/0.3)] transition-all duration-500 group ${
                  isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
                }`}
                style={{ transitionDelay: `${i * 150 + 200}ms` }}
              >
                <div className="w-16 h-16 rounded-2xl bg-[oklch(0.52_0.09_128/0.1)] flex items-center justify-center mx-auto mb-6 group-hover:bg-[oklch(0.52_0.09_128/0.2)] transition-colors">
                  <Icon className="text-[oklch(0.52_0.09_128)]" size={28} />
                </div>
                <h3 className="text-xl font-bold text-[oklch(0.25_0.04_50)] mb-3">{t(group.titleKey as any)}</h3>
                <p className="text-[oklch(0.5_0.03_50)]" style={{ fontFamily: "var(--font-body)" }}>
                  {t(group.descriptionKey as any)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
